import { lazy } from "react";

const FTLTripPlanTableLoadable = lazy(() => import("./FTLTripPlanTable"));

export { FTLTripPlanTableLoadable };